import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProcedureStepSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/"
					to="/$organizationId/settings/procedure-types/$procedureTypeId/steps"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Steps
					</Button>
				</Link>
			}
		/>
	)
})
ProcedureStepSettingsDetailViewTopBar.displayName = "ProcedureStepSettingsDetailViewTopBar"
